import React from "react";
import get from "lodash/get";
import { useSelector, useDispatch } from "react-redux";
import { object, string } from "prop-types";
import PeopleIcon from "../PeopleIcon";
import Button from "../Button";
import { navigateTo } from "../../../arrow/utils/utils";
import { trackCtaClick } from "../../../ga-utils";
import { STATIC_KEYWORDS } from "../../../constants";
import "./member-icon.m.css";
import { SignInAvatar } from "../../../arrow/components/Svgs/sign-in-avatar";

const AuthButton = ({ onMenuToggle, label, path, customStyleName = "bg-brand-primary", isMobileTopbar = false }) => {
  const member = useSelector((state) => get(state, ["member"], null));
  const allStates = useSelector((state) => state);
  const qtState = get(allStates, ["qt"], {});
  const pageType = qtState.pageType;
  const dispatch = useDispatch();
  const { SIGN_IN } = STATIC_KEYWORDS;

  //if (pageType === "user-login") return null;

  const imgUrl = get(member, ["avatar-url"], null);
  const name = get(member, ["name"], "");

  const handleClick = (link) => () => {
    onMenuToggle && onMenuToggle();

    if (link === "/user-login" && typeof window !== "undefined") {
      trackCtaClick({
        linkText: SIGN_IN.toLowerCase(),
        linkUrl: "/user-login",
        linkCategory: "login",
        pageType,
        story: qtState?.data?.story,
        location: window.location,
      });
    }

    navigateTo(dispatch, link);
  };

  return (
    <div styleName="auth-button-wrapper">
      {member ? (
        <Button disableAjaxLinks={false} onClickFunction={handleClick("/profile")}>
          <div styleName="profileImage">{imgUrl ? <img alt={name} src={imgUrl} /> : <PeopleIcon />}</div> My Account
        </Button>
      ) : (
        <Button
          onClickFunction={handleClick(path)}
          disableAjaxLinks={false}
          ariaLabel={`Go to ${label} page`}
          customStyleName={customStyleName}
        >
           {isMobileTopbar && <SignInAvatar />} {label}
        </Button>
      )}
    </div>
  );
};

AuthButton.propTypes = {
  member: object,
  pageType: string,
};

export default AuthButton;
